import { MutationTree } from 'vuex';
import { ThumbnailMutationTypes, ThumbnailState, ThumbnailViewModel } from '@/types';

export const mutations: MutationTree<ThumbnailState> = {
  [ThumbnailMutationTypes.AddThumbnail](state, payload: ThumbnailViewModel) {
    const index = state.thumbnails.findIndex((x: ThumbnailViewModel) => x.documentId === payload.documentId && x.page === payload.page);
    if (index === -1) {
      state.thumbnails.push(payload);
    } else {
      const thumbnails = [...state.thumbnails];
      thumbnails[index] = payload;
      state.thumbnails = [...thumbnails];
    }
  },
  [ThumbnailMutationTypes.RemoveThumbnailPagesForDocument](state, { documentId, pages }) {
    for (let i = state.thumbnails.length - 1; i >= 0; i--) {
      const thumbnail = state.thumbnails[i];
      if (thumbnail.documentId === documentId && pages.some((page: number) => thumbnail.page === page)) {
        state.thumbnails.splice(i, 1);
      }
    }

    const docThumbnails = state.thumbnails.filter((x) => x.documentId === documentId).sort((a, b) => a.page - b.page);

    for (const thumbnail of docThumbnails) {
      const pagesDeletedWithALowerPageNumber = pages.filter((page: number) => thumbnail.page > page).length;
      if (pages.some((page: number) => thumbnail.page > page)) {
        thumbnail.page = thumbnail.page - pagesDeletedWithALowerPageNumber;
      }
    }
  },
  [ThumbnailMutationTypes.ClearThumbnailCacheForDocument](state, { documentId }) {
    for (let i = state.thumbnails.length - 1; i >= 0; i--) {
      const thumbnail = state.thumbnails[i];
      if (thumbnail?.documentId === documentId) {
        state.thumbnails.splice(i, 1);
      }
    }
  }
};
